import { PageTitle } from '_metronic/layout/core'

import SimpleFileUploader from 'Presentation/Components/Uploader/File/SimpleUploader'

import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import Select from 'react-select'
import { TABS } from '../Config'

import useViewModel from './ViewModel'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import clsx from 'clsx'

//////////
// View //
//////////

const ProfileBusinessInfoView: React.FC = () => {
	const isHorizontal = !isMobileDevice()
	const {
		companyName,
		currentTab,
		formState,
		updateProgress,
		uploadFileKey,
		onChange,
		onChangeTab,
		supplierTypeOptions,
		onSubmitInformation,
		// onSubmitAttachFile,
		onSubmitEmployee,
		isSubmitting,
		error,
		hasUploadFile,
		onDownload,
		onChangeFile,
	} = useViewModel()

	return (
		<ViewPageTitle companyName={companyName}>
			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={onChangeTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) onChangeTab(Number(selected?.value))
						}}
					/>
				</div>

				{/* Corporate Information */}
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0">
							<div className="d-flex flex-row align-items-center justify-content-between w-100 mt-5">
								{/* Title */}
								<div>
									<h2 className="text-kumopack-grey-900 fw-bold">ข้อมูลทางธุรกิจ</h2>
									<div className="text-kumopack-grey-600">
										Update your photo and personal details here.
									</div>
								</div>
							</div>
						</div>
						<div className="card-body pt-0">
							<hr className="mt-2" />

							<div className={`mt-10 mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>
											ประเภทร้านค้า <span className="required" />
										</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<Select
										isSearchable
										isClearable
										isMulti={false}
										options={supplierTypeOptions}
										styles={{
											control: baseStyles => ({
												...baseStyles,
												border: error.supplierType ? '1px solid #f1416c' : '1px solid #e1e3ea',
												borderRadius: 8,
												height: 40,
												zIndex: 10,
											}),
											menu: baseStyles => ({
												...baseStyles,
												zIndex: 10,
											}),
										}}
										className="w-100"
										components={{
											IndicatorSeparator: () => null,
										}}
										placeholder="เลือกประเภทร้านค้า"
										value={supplierTypeOptions.find(o => o.value === formState.supplierType)}
										onChange={val => {
											onChange('supplierType', val?.value)
										}}
									/>

									{error.supplierType && (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.supplierType}</div>
										</div>
									)}
								</div>
							</div>

							<FormGenerator
								formKey="companyName"
								inputType="plain"
								label="ชื่อบริษัท / ชื่อเจ้าของกิจการ"
								additionalLabelCom={<span className="required" />}
								containerClassName="mb-5"
								isHorizontal={isHorizontal}
								tooltip="Company Name"
								value={formState.companyName}
								onChange={e => onChange('companyName', e.target.value)}
								isShowValid={!!error?.companyName}
								additionalComInput={
									error?.companyName ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.companyName}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="companyTaxNo"
								inputType="plain"
								label="เลขประจำตัวผู้เสียภาษีอากร"
								additionalLabelCom={<span className="required" />}
								containerClassName="mb-5"
								markInput
								mark="9-9999-99999-99-9"
								markChar={null}
								isHorizontal={isHorizontal}
								tooltip="Tax ID"
								value={formState.companyTaxNo ?? ''}
								onChange={e => onChange('companyTaxNo', e.target.value)}
								isShowValid={!!error?.companyTaxNo}
								additionalComInput={
									error?.companyTaxNo ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.companyTaxNo}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="companyAddress"
								inputType="textarea"
								label="รายละเอียดที่อยู่"
								additionalLabel="Company Address"
								containerClassName="mb-5"
								isHorizontal={isHorizontal}
								limitCharacter={300}
								value={formState.companyAddress}
								onChange={e => onChange('companyAddress', e.target.value)}
							/>
						</div>
						<div className="card-footer text-end">
							<button
								disabled={isSubmitting}
								onClick={onSubmitInformation}
								className={clsx(
									'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
									{
										'w-200px': !isMobileDevice(),
										'w-sm-100': isMobileDevice(),
									}
								)}>
								บันทึก
							</button>
						</div>
					</div>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200 mt-5">
						<div className="card-header border-0">
							<div className="d-flex flex-row align-items-center justify-content-between w-100 mt-5">
								{/* Title */}
								<div>
									<h2 className="text-kumopack-grey-900 fw-bold">อัพโหลดเอกสารอื่นๆ</h2>
									<div className="text-kumopack-grey-600">please specify page description here</div>
								</div>
							</div>
						</div>
						<div className="card-body pt-0">
							<hr className="mt-2" />

							{/* หนังสือรับรองบริษัท */}
							<div className={`mt-10 mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>หนังสือรับรองบริษัท</span>
										<span className="text-kumopack-grey-400">(Up to: 20MB)</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<SimpleFileUploader
										fileKey="companyCertificateFile"
										file={formState.companyCertificateFile}
										onChange={onChangeFile}
										hasUpdate={hasUploadFile.companyCertificateFile}
										download={() => onDownload('companyCertificateFile')}
										isSubmitting={uploadFileKey === 'companyCertificateFile'}
										progression={updateProgress}
									/>
								</div>
							</div>

							{/* ภพ.20 */}
							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>เอกสารภพ.20</span>
										<span className="text-kumopack-grey-400">(Up to: 20MB)</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<SimpleFileUploader
										fileKey="companyVatRegistrationFile"
										file={formState.companyVatRegistrationFile}
										onChange={onChangeFile}
										hasUpdate={hasUploadFile.companyVatRegistrationFile}
										download={() => onDownload('companyVatRegistrationFile')}
										isSubmitting={uploadFileKey === 'companyVatRegistrationFile'}
										progression={updateProgress}
									/>
								</div>
							</div>

							{/* เอกสาร ISO */}
							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>เอกสาร ISO</span>
										<span className="text-kumopack-grey-400">(Up to: 20MB)</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<SimpleFileUploader
										fileKey="companyIsoFile"
										file={formState.companyIsoFile}
										onChange={onChangeFile}
										hasUpdate={hasUploadFile.companyIsoFile}
										download={() => onDownload('companyIsoFile')}
										isSubmitting={uploadFileKey === 'companyIsoFile'}
										progression={updateProgress}
									/>
								</div>
							</div>

							{/* เอกสารอื่นๆ */}
							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>เอกสารอื่นๆ</span>
										<span className="text-kumopack-grey-400">(Up to: 20MB)</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<SimpleFileUploader
										fileKey="companyOtherFile"
										file={formState.companyOtherFile}
										onChange={onChangeFile}
										hasUpdate={hasUploadFile.companyOtherFile}
										download={() => onDownload('companyOtherFile')}
										isSubmitting={uploadFileKey === 'companyOtherFile'}
										progression={updateProgress}
									/>
								</div>
							</div>
						</div>
						{/* <div className="card-footer text-end">
							<button
								disabled={isSubmitting}
								onClick={onSubmitAttachFile}
								className={clsx(
									'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
									{
										'w-200px': !isMobileDevice(),
										'w-sm-100': isMobileDevice(),
									}
								)}>
								บันทึก
							</button>
						</div> */}
					</div>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200 mt-5">
						<div className="card-header border-0">
							<div className="d-flex flex-row align-items-center justify-content-between w-100 mt-5">
								{/* Title */}
								<div>
									<h2 className="text-kumopack-grey-900 fw-bold">ความสามารถในการผลิต</h2>
									<div className="text-kumopack-grey-600">please specify page description here</div>
								</div>
							</div>
						</div>
						<div className="card-body pt-0">
							<hr className="mt-2" />

							<FormGenerator
								formKey="totalEmployee"
								inputType="plain"
								type="number"
								label="จำนวนพนักงาน"
								containerClassName="mt-10 mb-5"
								isHorizontal={isHorizontal}
								tooltip="จำนวนพนักงาน"
								value={formState.totalEmployee}
								onChange={e => onChange('totalEmployee', e.target.value)}
							/>

							<FormGenerator
								formKey="minimumProductionQuantity"
								inputType="plain"
								label="ความสามารถในการผลิตขั้นต่ำ (จำนวนใบต่อเดือน)"
								containerClassName="mt-10 mb-5"
								isHorizontal={isHorizontal}
								tooltip="ความสามารถในการผลิตขั้นต่ำ"
								value={formState.minimumProductionQuantity}
								onChange={e => onChange('minimumProductionQuantity', e.target.value)}
							/>
						</div>
						<div className="card-footer text-end">
							<button
								disabled={isSubmitting}
								onClick={onSubmitEmployee}
								className={clsx(
									'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
									{
										'w-200px': !isMobileDevice(),
										'w-sm-100': isMobileDevice(),
									}
								)}>
								บันทึก
							</button>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Business Information',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default ProfileBusinessInfoView
